import { FileListType } from './FileListType'

export class FileType extends FileListType {
  static getDefaultTypeParams() {
    return FileListType.extendTypeParams({
      maxFiles: 1,
    })
  }
}
